import React from 'react';
import Icon from '../../../components/AppIcon';
import LeadCard from './LeadCard';

const KanbanColumn = ({ 
  stage, 
  leads, 
  onDragStart, 
  onDragOver, 
  onDrop, 
  onAssignOwner, 
  onAddNote, 
  onConvert,
  draggedLead,
  onStageChange
}) => {
  const stageConfig = {
    'new': { label: 'New Leads', icon: 'Inbox', color: 'text-primary' },
    'contacted': { label: 'Contacted', icon: 'Phone', color: 'text-secondary' },
    'qualified': { label: 'Qualified', icon: 'CheckCircle', color: 'text-success' },
    'proposal': { label: 'Proposal Sent', icon: 'FileText', color: 'text-warning' },
    'negotiation': { label: 'Negotiation', icon: 'MessageSquare', color: 'text-accent' },
    'lost': { label: 'Lost', icon: 'XCircle', color: 'text-error' }
  };

  const config = stageConfig?.[stage] || stageConfig?.['new'];
  const stageLeads = leads?.filter(lead => lead?.stage === stage);

  return (
    <div className="flex-shrink-0 w-80 md:w-96">
      <div className="bg-card rounded-lg border border-border h-full flex flex-col">
        <div className="p-4 border-b border-border bg-muted bg-opacity-30">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icon name={config?.icon} size={20} color={`var(--color-${config?.color?.replace('text-', '')})`} />
              <h3 className="font-heading font-semibold text-foreground text-base">
                {config?.label}
              </h3>
            </div>
            <span className="px-2 py-1 bg-primary bg-opacity-10 text-primary rounded-lg text-xs font-semibold data-text">
              {stageLeads?.length}
            </span>
          </div>
        </div>

        <div
          className="flex-1 p-4 overflow-y-auto min-h-[400px] max-h-[calc(100vh-300px)]"
          onDragOver={onDragOver}
          onDrop={(e) => onDrop(e, stage)}
        >
          {stageLeads?.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center py-8">
              <Icon name="Inbox" size={48} color="var(--color-muted-foreground)" className="mb-3 opacity-30" />
              <p className="text-sm caption text-muted-foreground">No leads in this stage</p>
            </div>
          ) : (
            stageLeads?.map(lead => (
              <div
                key={lead?.id}
                draggable
                onDragStart={(e) => onDragStart(e, lead)}
              >
                <LeadCard
                  lead={lead}
                  onAssignOwner={onAssignOwner}
                  onAddNote={onAddNote}
                  onConvert={onConvert}
                  isDragging={draggedLead?.id === lead?.id}
                  onStageChange={onStageChange}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default KanbanColumn;